import { buildUri } from "../../utils/dom";

export class ThemeService {

    #style = null;
    #customFontPath = "";

    
    init(resourcesService, style) {

        this.#style = style;

        const primaryColor = resourcesService.getResource('SELFSCHEDULER_PRIMARY_COLOR','#000000');
        const secondaryColor = resourcesService.getResource('SELFSCHEDULER_SECONDARY_COLOR','#000000');
        const tertiaryColor = resourcesService.getResource('SELFSCHEDULER_TERTIARY_COLOR','#ffffff');
        const borderRadius = resourcesService.getResource('SELFSCHEDULER_BORDER_RADIUS','10px');
        const headerColor = resourcesService.getResource('SELFSCHEDULER_HEADER_COLOR', primaryColor);
        const headerTextColor = resourcesService.getResource('SELFSCHEDULER_HEADER_TEXT_COLOR', primaryColor);
        const closeButtonColor = resourcesService.getResource('SELFSCHEDULER_CLOSE_BUTTON_COLOR','#000000');
        const todayColor = resourcesService.getResource('SELFSCHEDULER_CALDATE_TODAY_COLOR','#000000');
        const todayBackgroundColor = resourcesService.getResource('SELFSCHEDULER_CALDATE_TODAY_BACKGROUND_COLOR','#ebede6');
        const selectedDateColor = resourcesService.getResource('SELFSCHEDULER_CALDATE_SELECTED_DATE_COLOR', primaryColor);
        const selectedDateTextColor = resourcesService.getResource('SELFSCHEDULER_CALDATE_SELECTED_DATE_TEXT_COLOR', '#E7E9ED');
        const calBorderRadius = resourcesService.getResource('SELFSCHEDULER_CALENDAR_BORDER_RADIUS','10px');
        const calArrowColor = resourcesService.getResource('SELFSCHEDULER_CALENDAR_ARROW_COLOR', secondaryColor);
        const buttonBorderRadius = resourcesService.getResource('SELFSCHEDULER_BUTTON_BORDER_RADIUS','10px');
        const panelBorderRadius = resourcesService.getResource('SELFSCHEDULER_PANEL_BORDER_RADIUS','6px');
        const inputBorderRadius = resourcesService.getResource('SELFSCHEDULER_INPUT_BORDER_RADIUS','4px');
        const todayRadius = resourcesService.getResource('SELFSCHEDULER_CALDATE_BORDER_RADIUS','25px');
        const sidePanelHorizontalOffset = resourcesService.getResource('SELFSCHEDULER_SIDE_PANEL_HORIZONTAL_OFFSET','30px');
        const sidePanelVerticalOffset = resourcesService.getResource('SELFSCHEDULER_SIDE_PANEL_VERTICAL_OFFSET','10px');
        const navgationBackArrowColor = resourcesService.getResource('SELFSCHEDULER_NAVIGATION_BACK_ARROW_COLOR', '#ffffff');
        const navgationNextArrowColor = resourcesService.getResource('SELFSCHEDULER_NAVIGATION_NEXT_ARROW_COLOR', '#ffffff');
        const timeslotTextColor = resourcesService.getResource('SELFSCHEDULER_TIMESLOT_BUTTON_TEXT_COLOR','#000000');
        const backButtonColor = resourcesService.getResource('SELFSCHEDULER_BACK_BUTTON_COLOR', primaryColor);
        const backButtonTextColor = resourcesService.getResource('SELFSCHEDULER_BACK_BUTTON_TEXT_COLOR', '#FFF');
        const nextButtonColor = resourcesService.getResource('SELFSCHEDULER_NEXT_BUTTON_COLOR', primaryColor);
        const nextButtonTextColor = resourcesService.getResource('SELFSCHEDULER_NEXT_BUTTON_TEXT_COLOR', '#FFF');
        const panelBoxShadow = resourcesService.getResource('SELFSCHEDULER_PANEL_BOX_SHADOW', '4.6px -0.1px 9.1px #0000002b');
        const errorColor = resourcesService.getResource('SELFSCHEDULER_ERROR_COLOR', 'red');
        const bodyFontSize =  resourcesService.getResource('SELFSCHEDULER_BODY_FONT_SIZE', '14px');
        
        this.#customFontPath = resourcesService.getResource('SELFSCHEDULER_FONT_CSS_PATH', '');
        

        this.#setStyleVar('--selfscheduler-border-radius', borderRadius);
        this.#setStyleVar('--selfscheduler-primary-color', primaryColor);
        this.#setStyleVar('--selfscheduler-secondary-color', secondaryColor);
        this.#setStyleVar('--selfscheduler-tertiary-color', tertiaryColor);
        this.#setStyleVar('--selfscheduler-header-color', headerColor);
        this.#setStyleVar('--selfscheduler-header-text-color', headerTextColor);
        this.#setStyleVar('--selfscheduler-closebutton-color', closeButtonColor);
        this.#setStyleVar('--selfscheduler-calendar-border-radius', calBorderRadius);
        this.#setStyleVar('--selfscheduler-calendar-arrow-color', calArrowColor);
        this.#setStyleVar('--selfscheduler-input-border-radius', inputBorderRadius);
        this.#setStyleVar('--selfscheduler-button-border-radius', buttonBorderRadius);
        this.#setStyleVar('--v24cal-today-color', todayColor);
        this.#setStyleVar('--v24cal-today-bg-color', todayBackgroundColor);
        this.#setStyleVar('--v24cal-selected-date-color', selectedDateColor);
        this.#setStyleVar('--v24cal-selected-color', selectedDateTextColor);
        this.#setStyleVar('--v24cal-today-radius', todayRadius);
        this.#setStyleVar('--selfscheduler-side-panel-horizontal-offset', sidePanelHorizontalOffset);
        this.#setStyleVar('--selfscheduler-side-panel-vertical-offset', sidePanelVerticalOffset);
        this.#setStyleVar('--selfscheduler-navigation-back-arrow-color', navgationBackArrowColor);
        this.#setStyleVar('--selfscheduler-navigation-next-arrow-color', navgationNextArrowColor);
        this.#setStyleVar('--selfscheduler-timeslot-text-color', timeslotTextColor);
        this.#setStyleVar('--selfscheduler-panel-radius', panelBorderRadius);
        this.#setStyleVar('--selfscheduler-back-button-color', backButtonColor);
        this.#setStyleVar('--selfscheduler-next-button-color', nextButtonColor);
        this.#setStyleVar('--selfscheduler-back-button-text-color', backButtonTextColor);
        this.#setStyleVar('--selfscheduler-next-button-text-color', nextButtonTextColor);
        this.#setStyleVar('--selfscheduler-panel-shadow', panelBoxShadow);
        this.#setStyleVar('--selfscheduler-error-color', errorColor);
        this.#setStyleVar('--v24-font-size', bodyFontSize);
        
    }

    get customFontPath() {
        if (this.#customFontPath?.length > 0) {
            this.#customFontPath = buildUri(v24Scheduler.staticDomain,  this.#customFontPath);
        }
        return  this.#customFontPath;
    }

    #setStyleVar(name, value) {
        this.#style.setProperty(name, value);
    }
}